import { apiResolver, useApi } from "@/api/useApi";
import {
  BaseTracker,
  Tracker,
  TrackerItem,
  TrackerStage,
  TrackerFieldType,
  TrackerAlertConfig,
} from "./Tracker.model";

export type Sources = "tickets" | "conversations";

export interface TrackerColumnInput {
  stage: TrackerStage;
  name: string;
  tags: string[];
}

export interface TrackerCreateOrUpdateInput {
  name?: string;
  sources?: Sources[];
  matchRules?: object;
  columns?: TrackerColumnInput[];
  fields?: TrackerFieldType[];
  tags?: string[];
  alertConfig?: TrackerAlertConfig | null;
}

export function useTrackerApi() {
  const { api } = useApi();

  return {
    getTrackers: async () =>
      apiResolver<BaseTracker[]>(api.get("/platform/tracker")),
    getTracker: async (trackerId: string) =>
      apiResolver<Tracker>(api.get(`/platform/tracker/${trackerId}`)),
    getTrackerItems: async (trackerId: string, timeFilter?: number) =>
      apiResolver<TrackerItem[]>(
        api.get(
          `/platform/tracker/${trackerId}/items${
            timeFilter ? `?timeFilter=${timeFilter}` : ""
          }`
        )
      ),
    getTrackerItemBySource: async (source: string, originalId: string) =>
      apiResolver<TrackerItem[]>(
        api.get(`/platform/tracker/items/${source}/${originalId}`)
      ),
    updateTrackerItemComment: async (
      trackerId: string,
      trackerItemId: string,
      comment: string
    ) =>
      api.put<void>(
        `/platform/tracker/${trackerId}/items/${trackerItemId}/comment`,
        { comment }
      ),
    updateTrackerItemColumn: async (
      trackerId: string,
      trackerItemId: string,
      columnId: string
    ) =>
      api.put<void>(
        `/platform/tracker/${trackerId}/items/${trackerItemId}/column`,
        { columnId }
      ),
    createTracker: async (input: TrackerCreateOrUpdateInput) =>
      apiResolver<Tracker>(api.post("/platform/tracker", input)),
    updateTracker: async (
      trackerId: string,
      input: TrackerCreateOrUpdateInput
    ) => apiResolver<Tracker>(api.put(`/platform/tracker/${trackerId}`, input)),
    archiveTracker: async (trackerId: string, isArchived: boolean) =>
      apiResolver<void>(
        api.put(`/platform/tracker/${trackerId}/archive`, { isArchived })
      ),
  };
}
